module.exports = {
    FOURTH_GIG_PACKAGE: 2333,
    CHAM_PERSONALIZED_CONTENT_GIG_PAGE: 2356,
    PRO_GIG_PAGE_UPDATE: 2407
};
